import React from "react";
import '../../../files/css/chat.css'
import {useTranslation} from "react-i18next";
import {Typography} from "@mui/material";
import ChatItem from "./ChatItem";

const ChatViewer = ({messages}) => {
    const { t } = useTranslation();
    return (
        <>
            {
                !!messages.length ?
                    <>
                        {messages.map((msg) => (
                            <ChatItem key={msg.id} msg={msg} view first_id={messages[0]?.sender_id}/>
                        ))}
                    </>
                    :
                    <div>
                        <Typography>{t('noMessage')}</Typography>
                    </div>
            }
        </>
    );
};

export default ChatViewer;
